export default function () {
  const widgetName = "tier2Cards";
  const widgetOpts = tier2CardsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    maxItemsVisible: 3,
    itemsPerPanel: 3,
    buyNowButton: false,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    moreButton: false,
    textOverImage: false,
    link: ["image"],
    
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        createCustomCards(widgetData);
      }
    },
  });

  function createCustomCards(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { URL } = widgetData[x];
      let $card = $(this);


      $card.attr({
        "data-aos": "zoom-in",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "180",
        "data-aos-delay": (x + 1) * 250,
        "data-aos-once": "true",
        "data-aos-offset": "200"

      })

      $card.find(".image-container").removeAttr("target");

      if (!URL) {
        $card.find(".image-container").removeAttr("href");
      }
    });
  }
}
